import { useSelector } from 'react-redux';
import { getFormattedTime } from '@redturtle/volto-io-prenoto/helpers/date';

const FormattedDate = ({ date, format = 'date' }) => {
  const siteTZ = useSelector(
    (state) => state?.site?.data['plone.portal_timezone'],
  );

  return getFormattedTime({ date: date, tz: siteTZ, format: format });
};

export default FormattedDate;
